import { Pipe, PipeTransform } from '@angular/core';
import { ResourcesService } from '../../tunnelsante/services/resources/resources.service';

@Pipe({ name: 'wzI18nEnum', standalone: false })
export class I18nEnumPipe implements PipeTransform {
  constructor(private resourcesService: ResourcesService) {}

  transform(value: number | string, enumName: string): string {
    if (enumName === undefined) {
      throw Error('property enumName is null');
    }

    return this.resourcesService.getResourceEnum(value, enumName);
  }
}

@Pipe({ name: 'wzI18nError', standalone: false })
export class I18nErrorPipe implements PipeTransform {
  constructor(private resourcesService: ResourcesService) {}

  transform(value: number, fallback?: string): string {
    return this.resourcesService.getErrorResource(value, fallback);
  }
}
